import { Component, OnInit, ViewChild } from '@angular/core';
import { WpService } from '../../../wp.service';
import { Observable } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { Alert } from 'selenium-webdriver';


@Component({
  selector: 'app-decom',
  templateUrl: './decom.component.html',
  styleUrls: ['./decom.component.scss']
})

export class DecomComponent implements OnInit {
  
  ngOnInit(): void {
  }
  @ViewChild('formanticipo',{static: true})formanticipo: NgForm;

  anticipoTotal: any[]=[];  
  i: any; //tasa de interes administrativa efectiva mensual
  cuota: any; // interes + amortizacionCapital
  interes:any; //  saldo x i
  saldo: any; // valor de la deuda del periodo anterior - amortizacion del periodo anterior
  amortizacionCapital: any; // cuota - interes

  //cantidadCuotas: any; // 6 - 12 -18 - 24 - 30
  //valorAnticipo: any; //valor del anticipo tomado hasta $80.000   
  gastoAdministrativo: any; //tasa de gasto administrativo 0.5%
  seguro: any; //tasa de seguro 0.25%
  CuotaPagar: any; // cuota + seguro + gasto

  id: any;
  feedDecom: Observable<any[]>;
  constructor(private wp: WpService, private route: ActivatedRoute) {     
    this.feedDecom = this.wp.getPostsDeCom();
    this.route.url.subscribe(u => {
      this.id = this.route.snapshot.params.id;
    });

    this.i = 0.0291666666666667;
    //%35
    this.cuota = 0;
    this.anticipoTotal   = [];  
    this.interes = 0;
    this.saldo= 0;
    this.amortizacionCapital=0;  
    this.gastoAdministrativo= 0;
    this.seguro= 0;
    this.CuotaPagar=0;  
  }


  anticipo(){
    
    let valorAnticipo = Number(this.formanticipo.value.valorAnticipo);
    let cantidadCuotas = Number(this.formanticipo.value.cantidadCuotas);    
    let resultado0 = 1 + this.i;
    let resultado = (Math.pow(resultado0,cantidadCuotas))* this.i;
    let resultado2 = (Math.pow(resultado0,cantidadCuotas))-1;
    let resultado3 = resultado/resultado2;
    this.cuota = valorAnticipo * (resultado3);    
    //let saldoAnterior = valorAnticipo;
    this.saldo = valorAnticipo;
    
    for (let index = 0; index < cantidadCuotas; index++){
      this.gastoAdministrativo = this.saldo * 0.005;      
      this.seguro = (this.saldo * 0.0025);  
      console.log(this.gastoAdministrativo);
      console.log(this.seguro);
      if (index == 0) {
        this.interes = valorAnticipo*this.i;
        this.amortizacionCapital = this.cuota-this.interes;
        this.saldo = valorAnticipo - this.amortizacionCapital;
      }else{
        this.interes = this.anticipoTotal[index-1].saldo*this.i;
        this.amortizacionCapital = this.cuota-this.interes;
        this.saldo = this.anticipoTotal[index-1].saldo - this.amortizacionCapital;
      }      
      
      
      this.CuotaPagar = String(this.cuota + this.gastoAdministrativo + this.seguro);
      let index2 = String(index+1);
      let cuota2 = String(this.cuota);
      let saldo2 = String(this.saldo);
      let interes2 = String(this.interes);
      let amortizacionCapital2 = String(this.amortizacionCapital);
      this.anticipoTotal[index] = {'index': index2, 'saldo': saldo2, 'amortizacionCapital' : amortizacionCapital2, 'interes': interes2, 'cuota': cuota2, 'cuotaPagar': this.CuotaPagar};
      
      
    }
     console.log(this.anticipoTotal); 
         
    this.formanticipo.reset();
    //this.reinicio();
  }
  reinicio(){
    this.i = 0.1091667;
    this.cuota = 0;
    this.anticipoTotal   = [];  
    this.interes = 0;
    this.saldo= 0;
    this.amortizacionCapital=0;  
    this.gastoAdministrativo= 0;
    this.seguro= 0;
    this.CuotaPagar=0; 
  }

}
